import React from 'react'
import { Loader } from 'react-bulma-components'
import Table from '../table'
import { Column, ColumnInterfaceBasedOnValue, ColumnWithLooseAccessor } from 'react-table'
import { Paths, ConditionalPickDeep, Primitive, SetOptional } from 'type-fest'

type TableColumn<Schema extends object = object> = Omit<Column<Schema>, 'accessor'> & {
  accessor: ReactQueryAccessor<Schema> | ColumnWithLooseAccessor<Schema>['accessor']
  Cell?: ColumnInterfaceBasedOnValue<Schema>['Cell']
}

type ReactQueryAccessor<Schema extends object = object> = Paths<
  ConditionalPickDeep<Schema, Primitive | Date>,
  { maxRecursionDepth: 4 }
>

export type BetterTableColumnDefinition<Schema extends object> = {
  [Key: string]: SetOptional<TableColumn<Schema>, 'accessor'> | null
}

export type BetterTableProps<Schema extends object, ColumnsDefinition> = {
  data?: Array<Schema>
  keys: Array<keyof ColumnsDefinition>
  omitKeys?: Array<keyof ColumnsDefinition>
  columns: ColumnsDefinition
  noDataMessage?: string
}

export const BetterTable = <Schema extends object, ColumnsDefinition extends object>({
  data,
  keys,
  omitKeys = [],
  columns,
  noDataMessage = 'Aucune donnée à afficher',
}: BetterTableProps<Schema, ColumnsDefinition>): React.ReactNode => {
  if (data === undefined) return <Loader />

  const keyedColumns =
    keys
      ?.filter(key => !omitKeys.includes(key))
      .map(key => ({
        ...columns[key],
        id: key,
      })) ?? []

  return (
    <Table<Schema>
      //@ts-expect-error
      columns={keyedColumns}
      data={data}
      noDataMessage={noDataMessage}
    />
  )
}
